import React from 'react';
import { ScreenSizeDetector } from '../../../../../lib/helpers';
import { VolumePrUnit } from '../../../../Format';
import { Col } from '../../../../grid';
import { Bold, Paragraph } from '../../../../typography';

const RenderSizeBottlesAndGlass = ({
  productTypeReservedel,
  SizeGlass,
  productTypeGlass,
  liter,
  countPrColli,
  productTypeFadoel,
  productTypePack,
}) => {
  if (productTypeReservedel || SizeGlass === 0 || productTypeFadoel || productTypePack) {
    return null;
  }
  return (
    <ScreenSizeDetector padding={[[1599, '5px 15px'], '15px']}>
      <Col xs={6} sm={3} md={3} lg={6} xl={6} xxl={3}>
        <Paragraph marginBottom="0">
          <Bold>Størrelse</Bold><br />
          {!productTypeGlass && (<VolumePrUnit liter={liter} amount={countPrColli} />)}
          {productTypeGlass && (
            <React.Fragment>
              {SizeGlass >= 1000 && (
                <React.Fragment>
                  {SizeGlass / 1000} liter
                </React.Fragment>
              )}
              {SizeGlass < 1000 && (
                <React.Fragment>
                  {SizeGlass} cl
                </React.Fragment>
              )}
            </React.Fragment>
          )}
        </Paragraph>
      </Col>
    </ScreenSizeDetector>
  );
};

export default RenderSizeBottlesAndGlass;
